<template>
  <div>
    <b-modal
      id="user-verification-modal"
      centered
      hide-header
      hide-footer
      size="lg"
    >
      <Info v-if="showInfo" />

      <notTurkishCitizen
        v-if="
          userVerification.is_nin_validation_required &&
          !userVerification.nin_validated
        "
      />

      <div v-if="userVerification.is_email_validation_required">
        <EmailVerify
          v-if="!userVerification.is_email_validated"
          @startCountDown="startCountDownUpdate"
        />
        <EmailVerifyCompleted v-else />
      </div>

      <div
        v-if="userVerification.is_cellphone_validation_required"
        :disabled="!userVerification.is_email_validated"
      >
        <PhoneVerify v-if="!userVerification.is_cellphone_validated" />
        <PhoneVerifyCompleted v-else />
      </div>

      <div
        v-if="userVerification.is_nin_validation_required"
        :disabled="!userVerification.is_email_validated"
      >
        <NinVerify v-if="!userVerification.nin_validated" />
        <NinVerifyCompleted v-else />
      </div>
    </b-modal>

    <RedirectLoginModal :startCountDown="startCountDown"></RedirectLoginModal>
  </div>
</template>

<script>
// Services
import { mapGetters } from 'vuex'

export default {
  name: 'VerificationModal',
  props: {
    showInfo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      startCountDown: false,
    }
  },
  computed: {
    ...mapGetters(['userVerification']),
  },
  methods: {
    startCountDownUpdate(payload) {
      this.startCountDown = payload
      this.$bvModal.show('modal-redirect-login')
    },
  },
  components: {
    Info: () => import('@/components/userVerifications/Info'),
    EmailVerify: () => import('@/components/userVerifications/EmailVerify'),
    EmailVerifyCompleted: () =>
      import('@/components/userVerifications/EmailVerifyCompleted'),
    PhoneVerify: () => import('@/components/userVerifications/PhoneVerify'),
    PhoneVerifyCompleted: () =>
      import('@/components/userVerifications/PhoneVerifyCompleted'),
    NinVerify: () => import('@/components/userVerifications/NinVerify'),
    NinVerifyCompleted: () =>
      import('@/components/userVerifications/NinVerifyCompleted'),
    notTurkishCitizen: () =>
      import('@/components/userVerifications/notTurkishCitizen'),
    RedirectLoginModal: () =>
      import('@/components/userVerifications/RedirectLoginModal'),
  },
}
</script>
